/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */

import React, { useState, useEffect } from "react";

// react-router components
import { useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
import { makeStyles } from "@mui/styles";
import { Box, InputLabel, MenuItem, Select, FormControl } from "@mui/material";
import { useTranslation } from "react-i18next";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
// import MDInput from "components/MDInput";

// Material Dashboard 2 React example components
// import Breadcrumbs from "examples/Breadcrumbs";
// import MDTypography from "components/MDTypography";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  // navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import { useMaterialUIController, setTransparentNavbar, setMiniSidenav } from "context";
import PswUpdateComponent from "examples/Navbars/DashboardNavbar/component/PswUpdateComponent";
import { PATH_LOGOUT, PATH_LOGIN } from "constant/moduleInfo";

// import betaclic_web from "assets/images/bordeu.PNG";
// import betaclic_web from "assets/images/web_banner.jpg";
import bannerImgOI from "assets/images/identite/banner_oi.png";
import bannerImgSahel from "assets/images/identite/banner_sahel.png";
// import MDTypography from "components/MDTypography";
// import COLORS from "constant/colors";
// import clientLogo from "assets/images/identite/client2.png";
import { CURRENT_ZONE, USER_DATA_STORAGE } from "constant";

import HeaderMPSA from "layouts/gestion_sante_animale/component/headerMPSA";

const useStyles = makeStyles((theme) => ({
  banner: {
    backgroundColor: "#2196f3",
    color: "#fff",
    padding: theme.spacing(2),
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1),
    },
  },
  bannerImage: {
    maxWidth: "100%",
    height: "auto",
    width: "100%",
  },

  logoSigninRow: {
    display: "flex",
    justifyContent: "center", // Centre l'image horizontalement
    alignItems: "center",
    marginTop: 15,
    // backgroundColor: "red",
  },

  logoSigninClient: {
    width: "40%",
    height: "auto" /* Maintain aspect ratio */,
    // marginTop: 15,
  },
}));

function DashboardNavbar({ absolute, light, isMini }) {
  const navigate = useNavigate();
  const { i18n } = useTranslation();
  const { t } = useTranslation("translation");
  const [navbarType, setNavbarType] = useState();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, transparentNavbar, fixedNavbar, darkMode } = controller;
  const [openMenu, setOpenMenu] = useState(false);
  const [openDialogUser, setOpenDialogUser] = useState(false);
  const [bannerImg, setBannerImg] = useState("");
  const userToken = localStorage.getItem(USER_DATA_STORAGE);

  // const route = useLocation().pathname.split("/").slice(1);
  const classes = useStyles();
  useEffect(() => {
    // Setting the navbar type
    if (fixedNavbar) {
      setNavbarType("sticky");
    } else {
      setNavbarType("static");
    }

    // A function that sets the transparent state of the navbar.
    function handleTransparentNavbar() {
      setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
    }

    /**
     The event listener that's calling the handleTransparentNavbar function when
     scrolling the window.
    */
    window.addEventListener("scroll", handleTransparentNavbar);

    // Call the handleTransparentNavbar function to set the state with the initial value.
    handleTransparentNavbar();

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener("scroll", handleTransparentNavbar);
    };
  }, [dispatch, fixedNavbar]);
  useEffect(() => {
    if (CURRENT_ZONE === "OI") {
      setBannerImg(bannerImgOI);
    } else if (CURRENT_ZONE === "SAHEL") {
      setBannerImg(bannerImgSahel);
    }
  }, []);

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

  /* const handleOpenMenu = (event) => {
    setOpenMenu(event.currentTarget);
  }; */
  const handleCloseMenu = () => {
    setOpenMenu(false);
  };

  // Render the notifications menu
  const renderMenu = () => (
    <Menu
      anchorEl={openMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(openMenu)}
      onClose={handleCloseMenu}
      sx={{ mt: 2 }}
    >
      <Icon>email</Icon>
    </Menu>
  );

  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
    color: () => {
      let colorValue = light || darkMode ? white.main : dark.main;

      if (transparentNavbar && !light) {
        colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
      }

      return colorValue;
    },
  });
  const navigateToLogout = () => {
    // console.log("handleLogout", PATH_LOGOUT);
    navigate(PATH_LOGOUT);
  };
  const navigateToLogin = () => {
    // console.log("handleLogout", PATH_LOGOUT);
    navigate(PATH_LOGIN);
  };
  const handleUserDialog = () => {
    setOpenDialogUser(!openDialogUser);
  };
  const handleLanguageChange = (event) => {
    // console.log("new lg", event.target.value);
    // console.log("actual lg", i18n.resolvedLanguage);
    i18n
      .changeLanguage(event.target.value)
      .then((result) => {
        // Handle success
        // console.log(result);
      })
      .catch((error) => {
        // Handle error
        console.error(error);
      });
  };
  return (
    <AppBar
      position={absolute ? "absolute" : navbarType}
      color="inherit"
      sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
    >
      <MDBox
        variant="gradient"
        bgColor="inherit"
        borderRadius="lg"
        coloredShadow="info"
        // mx={2}
        // mt={-3}
        // mt={2}
        // p={2}
        // mb={10}
        textAlign="center"
        position="relative"
      >
        <img src={bannerImg} className={classes.bannerImage} alt="Beta Click" />
      </MDBox>

      {/* <MDTypography
        display="block"
        variant="H1"
        fontWeight="medium"
        align="center"
        style={{ color: COLORS.primary, marginBottom: 10 }}
      >
        <div className={classes.logoSigninRow}>
          <img src={clientLogo} alt="CIRAD" className={classes.logoSigninClient} />
        </div>
        Mallette Pédagogique Santé Animale Océan Indien
      </MDTypography> */}
      {/* <Box
        className={classes.logoSigninRow}
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        gap={2} // Ajoute un espacement entre l'image et le texte
        sx={{
          // backgroundColor: "red",
          flexDirection: { xs: "column", md: "row" }, // Colonne sur petits écrans et ligne sur grands écrans
        }}
      >
        <img
          src={clientLogo}
          alt="CIRAD"
          className={classes.logoSigninClient}
          style={{ maxWidth: "100%", height: "auto" }} // Rend l'image responsive
        />
        <MDTypography
          variant="h2"
          fontWeight="medium"
          sx={{ color: COLORS.primary, textAlign: "center", marginTop: { md: 1 } }} // Centre le texte sur petits écrans
        >
          {t("MPSA")}
        </MDTypography>
      </Box> */}
      <HeaderMPSA />
      <Toolbar sx={(theme) => navbarContainer(theme)}>
        {/* <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>
          <Breadcrumbs icon="home" title={route[route.length - 1]} route={route} light={light} />
        </MDBox> */}
        {isMini ? null : (
          <Box
            // bgcolor="lightblue" // Optionnel : couleur de fond pour visualisation
            display="flex"
            justifyContent="center"
            // sx={{ width: "100%" }}
            alignItems="center"
          >
            {/* <MDBox
            sx={{
              backgroundColor: "purple",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          > */}
            {/* <MDBox sx={(theme) => navbarRow(theme, { isMini })}> */}
            {/* <MDBox pr={1}>
              <MDInput label="Search here" />
            </MDBox> */}
            <MDBox
              color={light ? "white" : "inherit"}
              style={{ display: "flex", alignItems: "center", width: "100%" }}
            >
              {/* <Link to="/authentication/sign-in/basic">
                <IconButton sx={navbarIconButton} size="small" disableRipple>
                  <Icon sx={iconsStyle}>account_circle</Icon>
                </IconButton>
              </Link> */}

              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarMobileMenu}
                onClick={handleMiniSidenav}
              >
                <Icon sx={iconsStyle} fontSize="medium">
                  {miniSidenav ? "menu_open" : "menu"}
                </Icon>
              </IconButton>
              {/* <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
                onClick={handleOpenMenu}
              >
                 <Icon sx={iconsStyle}>notifications</Icon>
              </IconButton> */}
              {!userToken ? (
                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarIconButton}
                  aria-controls="notification-menu"
                  aria-haspopup="true"
                  variant="contained"
                  onClick={navigateToLogin}
                >
                  <Icon sx={[iconsStyle, { marginRight: 1 }]}>login</Icon>
                  {t("login")}
                </IconButton>
              ) : (
                <>
                  <IconButton
                    size="small"
                    disableRipple
                    color="inherit"
                    sx={navbarIconButton}
                    aria-controls="notification-menu"
                    aria-haspopup="true"
                    variant="contained"
                    onClick={handleUserDialog}
                  >
                    <Icon sx={iconsStyle}>account_circle</Icon>
                  </IconButton>

                  <IconButton
                    size="small"
                    disableRipple
                    color="inherit"
                    sx={navbarIconButton}
                    aria-controls="notification-menu"
                    aria-haspopup="true"
                    variant="contained"
                    onClick={navigateToLogout}
                  >
                    <Icon sx={iconsStyle}>power_settings_new</Icon>
                  </IconButton>
                </>
              )}
              <IconButton
                size="small"
                disableRipple
                color="inherit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
              >
                {/* <Icon sx={iconsStyle}>power_settings_new</Icon> */}
                <Box sx={{ minWidth: 120 }}>
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">{t("langage")}</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={i18n.resolvedLanguage}
                      label="Langage"
                      onChange={handleLanguageChange}
                      sx={{ padding: 1 }}
                    >
                      <MenuItem value={"fr"}>{t("lg_fr")}</MenuItem>
                      <MenuItem value={"en"}>{t("lg_en")}</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </IconButton>

              {openDialogUser && (
                <PswUpdateComponent open={openDialogUser} handleClose={handleUserDialog} />
              )}
              {renderMenu()}
            </MDBox>
            {/* </MDBox> */}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
